import React, { useState } from 'react';

const principles = [
    { icon: 'fa-heart',         title: 'Be Respectful',       desc: 'Treat all attendees, speakers, sponsors, and staff with respect. Harassment of any kind will not be tolerated.' },
    { icon: 'fa-users',         title: 'Be Inclusive',        desc: 'BSides welcomes people of all backgrounds, skill levels, genders, ethnicities, and beliefs. Discrimination is not welcome here.' },
    { icon: 'fa-comments',      title: 'Communicate Openly',  desc: 'Engage in constructive dialogue. Disagreements are fine — personal attacks are not. Critique ideas, not people.' },
    { icon: 'fa-shield-alt',    title: 'Respect Privacy',     desc: 'Do not photograph or record individuals without consent. Respect the privacy of others both online and offline.' },
    { icon: 'fa-gavel',         title: 'Follow the Rules',    desc: 'Abide by all venue rules, local laws, and BSides policies. Illegal activities will result in immediate removal.' },
    { icon: 'fa-hands-helping', title: 'Help Each Other',     desc: 'BSides is a community event. Share knowledge, mentor newcomers, and contribute to a positive atmosphere.' },
];

const reportSteps = [
    { step: '01', title: 'Contact Staff',    desc: 'Find any BSides staff member (identified by their badge/t-shirt) and report the incident immediately.' },
    { step: '02', title: 'Email Us', desc: 'Send a detailed report to info@bsidescoimbatore.in. All reports are treated confidentially.' },
    { step: '03', title: 'We Investigate',   desc: 'Our team will review the report promptly and take appropriate action, which may include removal from the event.' },
    { step: '04', title: 'Follow-up',        desc: 'We will follow up with the reporter (if they wish) and communicate the outcome of our investigation.' },
];

export default function CodeOfConductSection() {
    const [agreed, setAgreed] = useState(false);

    return (
        <section id="coc" className="bsides-coc">
            <style>{`
                .bsides-coc {
                    background: var(--eventflow-black);
                    padding: 100px 0;
                    position: relative;
                    overflow: hidden;
                }
                .bsides-coc::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background: radial-gradient(ellipse at 50% 0%, rgba(var(--eventflow-base-rgb),0.08) 0%, transparent 55%);
                    pointer-events: none;
                }

                /* alert banner */
                .coc-alert {
                    display: flex;
                    align-items: flex-start;
                    gap: 16px;
                    background: rgba(var(--eventflow-base-rgb),0.06);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.2);
                    border-radius: 12px;
                    padding: 20px 24px;
                    margin-bottom: 56px;
                    max-width: 800px;
                    margin-left: auto;
                    margin-right: auto;
                }
                .coc-alert i {
                    font-size: 20px;
                    color: var(--eventflow-base);
                    flex-shrink: 0;
                    margin-top: 2px;
                }
                .coc-alert p {
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    line-height: 1.65;
                    color: rgba(var(--eventflow-white-rgb),0.7);
                    margin: 0;
                }
                .coc-alert strong { color: var(--eventflow-white); }

                /* principles grid */
                .coc-principles {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 16px;
                    margin-bottom: 64px;
                }
                .coc-principle {
                    background: rgba(var(--eventflow-white-rgb),0.03);
                    border: 1px solid rgba(var(--eventflow-white-rgb),0.07);
                    border-radius: 12px;
                    padding: 28px 22px;
                    transition: all 0.3s;
                }
                .coc-principle:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.3);
                    transform: translateY(-3px);
                }
                .coc-principle__icon {
                    width: 44px; height: 44px;
                    border-radius: 10px;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    display: flex; align-items: center; justify-content: center;
                    margin-bottom: 16px;
                }
                .coc-principle__icon i { font-size: 18px; color: var(--eventflow-base); }
                .coc-principle__title {
                    font-family: var(--eventflow-font);
                    font-size: 15px;
                    font-weight: 700;
                    color: var(--eventflow-white);
                    margin-bottom: 8px;
                }
                .coc-principle__desc {
                    font-family: var(--eventflow-font);
                    font-size: 13px;
                    line-height: 1.65;
                    color: rgba(var(--eventflow-white-rgb),0.45);
                    margin: 0;
                }

                /* reporting steps */
                .coc-report-title {
                    font-family: var(--eventflow-font);
                    font-size: 28px;
                    font-weight: 800;
                    color: var(--eventflow-white);
                    text-align: center;
                    margin-bottom: 36px;
                }
                .coc-steps {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 16px;
                    margin-bottom: 56px;
                    position: relative;
                }
                .coc-steps::before {
                    content: '';
                    position: absolute;
                    top: 28px; left: 12.5%; right: 12.5%;
                    height: 1px;
                    background: rgba(var(--eventflow-white-rgb),0.08);
                    z-index: 0;
                }
                .coc-step {
                    text-align: center;
                    position: relative;
                    z-index: 1;
                }
                .coc-step__num {
                    width: 56px; height: 56px;
                    border-radius: 50%;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.25);
                    display: flex; align-items: center; justify-content: center;
                    margin: 0 auto 16px;
                    font-family: 'Courier New', monospace;
                    font-size: 14px;
                    font-weight: 700;
                    color: var(--eventflow-base);
                }
                .coc-step__title {
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    font-weight: 700;
                    color: var(--eventflow-white);
                    margin-bottom: 8px;
                }
                .coc-step__desc {
                    font-family: var(--eventflow-font);
                    font-size: 12px;
                    line-height: 1.6;
                    color: rgba(var(--eventflow-white-rgb),0.4);
                    margin: 0;
                }

                /* pledge */
                .coc-pledge {
                    background: rgba(var(--eventflow-white-rgb),0.03);
                    border: 1px solid rgba(var(--eventflow-white-rgb),0.07);
                    border-radius: 16px;
                    padding: 40px;
                    text-align: center;
                    max-width: 640px;
                    margin: 0 auto;
                }
                .coc-pledge h4 {
                    font-family: var(--eventflow-font);
                    font-size: 22px;
                    font-weight: 800;
                    color: var(--eventflow-white);
                    margin-bottom: 12px;
                }
                .coc-pledge p {
                    font-size: 14px;
                    color: rgba(var(--eventflow-white-rgb),0.45);
                    margin-bottom: 24px;
                    line-height: 1.7;
                }
                .coc-pledge__check {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    justify-content: center;
                    margin-bottom: 24px;
                    cursor: pointer;
                }
                .coc-pledge__check input { width: 18px; height: 18px; accent-color: var(--eventflow-base); cursor: pointer; }
                .coc-pledge__check label {
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    color: rgba(var(--eventflow-white-rgb),0.65);
                    cursor: pointer;
                }

                @media (max-width: 991px) {
                    .coc-principles { grid-template-columns: repeat(2,1fr); }
                    .coc-steps { grid-template-columns: repeat(2,1fr); }
                    .coc-steps::before { display: none; }
                }
                @media (max-width: 576px) {
                    .coc-principles { grid-template-columns: 1fr; }
                    .coc-steps { grid-template-columns: 1fr; }
                    .coc-pledge { padding: 24px 20px; }
                }
            `}</style>

            <div className="container">
                {/* Header */}
                <div className="text-center mb-4 wow fadeInUp" data-wow-delay="100ms">
                    <div className="bsides-section-tag" style={{justifyContent:'center'}}>Code of Conduct</div>
                    <h2 className="bsides-section-title" style={{textAlign:'center'}}>Safe Space for <span>Everyone</span></h2>
                    <p style={{color:'rgba(255,255,255,0.5)',fontSize:'15px',maxWidth:'520px',margin:'0 auto 40px'}}>
                        BSides Coimbatore is committed to providing a harassment-free experience for everyone, regardless of background or identity.
                    </p>
                </div>

                {/* Alert */}
                <div className="coc-alert wow fadeInUp" data-wow-delay="150ms">
                    <i className="fa fa-exclamation-circle" />
                    <p>
                        <strong>All attendees, speakers, sponsors, and volunteers are required to agree to this Code of Conduct.</strong>{' '}
                        Violations may result in expulsion from the event without refund. Organizers reserve the right to take any action deemed appropriate.
                    </p>
                </div>

                {/* Principles */}
                <div className="coc-principles wow fadeInUp" data-wow-delay="200ms">
                    {principles.map((p, i) => (
                        <div className="coc-principle" key={i}>
                            <div className="coc-principle__icon"><i className={`fa ${p.icon}`} /></div>
                            <div className="coc-principle__title">{p.title}</div>
                            <p className="coc-principle__desc">{p.desc}</p>
                        </div>
                    ))}
                </div>

                {/* Reporting */}
                <h3 className="coc-report-title wow fadeInUp" data-wow-delay="100ms">How to Report a Violation</h3>
                <div className="coc-steps wow fadeInUp" data-wow-delay="200ms">
                    {reportSteps.map((s, i) => (
                        <div className="coc-step" key={i}>
                            <div className="coc-step__num">{s.step}</div>
                            <div className="coc-step__title">{s.title}</div>
                            <p className="coc-step__desc">{s.desc}</p>
                        </div>
                    ))}
                </div>

                {/* Pledge */}
                <div className="coc-pledge wow fadeInUp" data-wow-delay="300ms">
                    <h4>Take the Pledge</h4>
                    <p>
                        By attending BSides Coimbatore 2027, you agree to uphold this Code of Conduct and help us create a welcoming, inclusive environment for the entire security community.
                    </p>
                    <div className="coc-pledge__check">
                        <input
                            type="checkbox"
                            id="coc-agree"
                            checked={agreed}
                            onChange={e => setAgreed(e.target.checked)}
                        />
                        <label htmlFor="coc-agree">I agree to the BSides Coimbatore Code of Conduct</label>
                    </div>
                    <a
                        href="/contact"
                        className={`thm-btn${!agreed ? ' disabled' : ''}`}
                        style={!agreed ? {opacity:0.4, pointerEvents:'none'} : {}}
                    >
                        Register Now <span className="icon-arrow-right" />
                    </a>
                </div>
            </div>
        </section>
    );
}
